import type {
  AtualizarCenarioSimuladorDto, CenarioSimuladorResponse, CenariosSimuladorListaResponse, SalvarCenarioSimuladorDto,
} from '@triade/contracts';
import { useConsulta, useMutacao } from './base';

/*
 * Cenarios do Simulador salvos (Sessao 28). A API guarda a mesa como o formulario a tem; o front so le e envia.
 * Chave ['cenarios-simulador'] cobre a lista e cada cenario (prefixo), entao toda gravacao invalida tudo.
 */

/** Lista (GET /cenarios-simulador): `precificacao.simular`. */
export function useCenariosSimulador() {
  return useConsulta<CenariosSimuladorListaResponse>(['cenarios-simulador'], '/cenarios-simulador');
}

/** Um cenario salvo com o `conteudo` (GET /cenarios-simulador/:id). Sem id, nao consulta. */
export function useCenarioSimulador(id: string | undefined) {
  return useConsulta<CenarioSimuladorResponse>(['cenarios-simulador', id], `/cenarios-simulador/${id}`, { ativo: !!id });
}

/** Cria (POST /cenarios-simulador). */
export function useSalvarCenarioSimulador() {
  return useMutacao<CenarioSimuladorResponse, SalvarCenarioSimuladorDto>({
    metodo: 'POST', caminho: () => '/cenarios-simulador', corpo: (v) => v, invalidar: [['cenarios-simulador']],
  });
}

/** Nome, anotacoes e/ou conteudo (PATCH /cenarios-simulador/:id). `anotacoes: null` limpa. */
export function useAtualizarCenarioSimulador() {
  return useMutacao<CenarioSimuladorResponse, { id: string } & AtualizarCenarioSimuladorDto>({
    metodo: 'PATCH',
    caminho: (v) => `/cenarios-simulador/${v.id}`,
    corpo: ({ id: _id, ...resto }) => resto,
    invalidar: [['cenarios-simulador']],
  });
}

/** Copia (POST /cenarios-simulador/:id/duplicar). */
export function useDuplicarCenarioSimulador() {
  return useMutacao<CenarioSimuladorResponse, { id: string }>({
    metodo: 'POST', caminho: (v) => `/cenarios-simulador/${v.id}/duplicar`, invalidar: [['cenarios-simulador']],
  });
}

/** Exclui (DELETE /cenarios-simulador/:id). */
export function useExcluirCenarioSimulador() {
  return useMutacao<void, { id: string }>({
    metodo: 'DELETE', caminho: (v) => `/cenarios-simulador/${v.id}`, invalidar: [['cenarios-simulador']],
  });
}
